import React, { Component } from 'react';
import { Spin, Tooltip, Icon, message } from 'antd';
import TableC from '../../basicElement/TableC';
import { RecommendFilter as Filter } from './Filter';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import InGroupRate from './InGroupRate';

class Recommend extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
        },
    }

    loadData = () => {
        this.setState({ loading: true });
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            method: 'POST',
            url: API_URL.commentInfo.querySiteRecommend,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            }, errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: { ...params },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.commentInfo.exportSiteRecommend,
            data: {
                ...sortParams,
                ...searchParams,
                offset: 1,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [{
            title: '筛选入组时间',
            dataIndex: 'statisticalTime',
            key: 'statisticalTime',
            fixed: 'left',
            width: 120,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            fixed: 'left',
            width: 120,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            fixed: 'left',
            width: 90,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 70,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 70,
        }, {
            title: '医院',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 160,
        }, {
            title: '县级行政区（如无则默认为上级行政单位）',
            dataIndex: 'hospitalCounty',
            key: 'hospitalCounty',
            width: 80,
        },  {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 100,
        }, {
            title: (
                <span>
                    医院最快启动时长
                    <Tooltip overlayStyle={{ width: 210, wordBreak: 'break-all' }} placement="top" title={'满足中心启动时间条件的研究中心最小启动时长'}>
                        <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'hospitalFastestStartUpTime',
            key: 'hospitalFastestStartUpTime',
            width: 85,
        }, {
            title: (
                <span>
                    医院平均启动时长
                    <Tooltip overlayStyle={{ width: 210, wordBreak: 'break-all' }} placement="top" title={'满足中心启动时间条件的研究中心平均启动时长'}>
                        <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'hospitalAverageStartUpTime',
            key: 'hospitalAverageStartUpTime',
            width: 85,
        }, {
            title: '伦理前置',
            dataIndex: 'ethicalPre',
            key: 'ethicalPre',
            width: 70,
        }, {
            title: '遗传办是否可以牵头',
            dataIndex: 'isGeneticOfficeCanLead',
            key: 'isGeneticOfficeCanLead',
            width: 80,
        }, {
            title: 'GCP资质有效期',
            dataIndex: 'qualificationPeriod',
            key: 'qualificationPeriod',
            width: 80,
        },  {
            title: '是否可以SMO主导启动',
            dataIndex: 'isSmoLeader',
            key: 'isSmoLeader',
            width: 80,
        },  {
            title: 'SMO与CRO属于同一集团',
            dataIndex: 'smoAndCroSame',
            key: 'smoAndCroSame',
            width: 80,
        },  {
            title: '津石是否在准入（优选）名单里（含签署优选战略合作协议医院）',
            dataIndex: 'jinshiIsInPro',
            key: 'jinshiIsInPro',
            width: 80,
        }, {
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 80,
        }, {
            title: '筛选病例数',
            dataIndex: 'filterAmount',
            key: 'filterAmount',
            width: 80,
        }, {
            title: '随机病例数',
            dataIndex: 'randomAmount',
            key: 'randomAmount',
            width: 80,
        }, {
            title: '科室月入组速率',
            dataIndex: 'monthlyEnrollmentRate',
            key: 'monthlyEnrollmentRate',
            width: 80,
            render: (text, record) => {
                return <a onClick={() => this.showInGroupRate(record)}>{text}</a>
            }
        }, {
            title: '科室病床数',
            dataIndex: 'departmentBedNum',
            key: 'departmentBedNum',
            width: 80,
        }, {
            title: '科室月住院量',
            dataIndex: 'monthlyHospitalizationNum',
            key: 'monthlyHospitalizationNum',
            width: 80,
        }, {
            title: '科室该疾病的月门诊量',
            dataIndex: 'outpatientNum',
            key: 'outpatientNum',
            width: 80,
        }, {
            title: '该疾病的出诊医生数量',
            dataIndex: 'visitingDoctor',
            key: 'visitingDoctor',
            width: 80,
        }, {
            title: '科室首次承接临床试验时间',
            dataIndex: 'clinicalTrialStartTime',
            key: 'clinicalTrialStartTime',
            width: 100,
        }, {
            title: '科室工作环境',
            dataIndex: 'workEnvironmentShow',
            key: 'workEnvironmentShow',
            width: 80,
        }, {
            title: '津石合作紧密程度',
            dataIndex: 'closeCooperationShow',
            key: 'closeCooperationShow',
            width: 80,
        }, {
            title: '无法合作原因',
            dataIndex: 'failureCooperateReason',
            key: 'failureCooperateReason',
            width: 80,
        }, {
            title: '科室综合推荐指数',
            dataIndex: 'recommendationIndexShow',
            key: 'recommendationIndexShow',
            width: 80,
        }, {
            title: '该科室竞争公司的CRC人数',
            dataIndex: 'competitionCrcNum',
            key: 'competitionCrcNum',
            width: 100,
        }, {
            title: '该科室津石公司的CRC人数',
            dataIndex: 'medkeyCrcNum',
            key: 'medkeyCrcNum',
            width: 100,
        }, {
            title: '该科室津石公司的CRC的临床试验经验最小时长(月)',
            dataIndex: 'minClinicalTrialExperience',
            key: 'minClinicalTrialExperience',
            width: 160,
        }, {
            title: '该科室津石公司的CRC的临床试验经验最大时长(月)',
            dataIndex: 'maxClinicalTrialExperience',
            key: 'maxClinicalTrialExperience',
            width: 160,
        }, {
            title: '该科室津石公司的CRC的临床试验经验分布',
            dataIndex: 'clinicalTrialExperienceDistribution',
            key: 'clinicalTrialExperienceDistribution',
            width: 140,
        }, {
            title: '该科室对SMO有无特殊要求',
            dataIndex: 'specialRequirementsShow',
            key: 'specialRequirementsShow',
            width: 100,
        }, {
            title: '科室备注',
            dataIndex: 'departmentRemark',
            key: 'departmentRemark',
            width: 120,
        }, {
            title: 'PI姓名',
            dataIndex: 'piUserCompellation',
            key: 'piUserCompellation',
            width: 80,
            render: (text, record) => {
                const { postStatus } = record;
                return  postStatus === 'OFF' ? `${text}(转岗)` : text;
            },
        }, {
            title: '在岗状态',
            dataIndex: 'postStatusShow',
            key: 'postStatusShow',
            width: 80,
        }, {
            title: 'PI负责筛选病例数',
            dataIndex: 'piFilterAmount',
            key: 'piFilterAmount',
            width: 80,
        }, {
            title: 'PI负责随机病例数',
            dataIndex: 'piRandomAmount',
            key: 'piRandomAmount',
            width: 80,
        }, {
            title: 'PI负责月入组速率',
            dataIndex: 'piMonthlyEnrollmentRate',
            key: 'piMonthlyEnrollmentRate',
            width: 80,
        }, {
            title: '该PI所在团队的GCP意识',
            dataIndex: 'gcpAwarenessShow',
            key: 'gcpAwarenessShow',
            width: 90,
        }, {
            title: '该PI所在团队的配合度',
            dataIndex: 'cooperationDegreeShow',
            key: 'cooperationDegreeShow',
            width: 80,
        }, {
            title: '该PI所在团队的CFDA视察经验',
            dataIndex: 'cfdaInspectionExperienceShow',
            key: 'cfdaInspectionExperienceShow',
            width: 100,
        }, {
            title: '该PI所在团队是否接受津石CRC服务',
            dataIndex: 'acceptCrcServiceShow',
            key: 'acceptCrcServiceShow',
            width: 120,
        }, {
            title: '该PI所在团队有无专人负责临床试验',
            dataIndex: 'speciallyAssignedPersonShow',
            key: 'speciallyAssignedPersonShow',
            width: 120,
        }, {
            title: '津石合作紧密程度',
            dataIndex: 'piCloseCooperationShow',
            key: 'piCloseCooperationShow',
            width: 80,
        }, {
            title: '该PI所在团队推荐指数',
            dataIndex: 'piRecommendationIndexShow',
            key: 'piRecommendationIndexShow',
            width: 80,
        }, {
            title: '该PI所在团队备注',
            dataIndex: 'comments',
            key: 'comments',
            width: 120,
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = (data || []).map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showInGroupRate = (record) => {
        this.inGroupRateRef.show(record);
    }

    render() {
        const { loading, pagination, searchParams } = this.state;
        return (
            <div>
                <Filter search={this.search} export={this.export} />
                <Spin spinning={loading}>
                    <TableC
                        scrollY={500}
                        className="recommend"
                        columns={this.getColumns()}                            
                        data={this.getDataSource()}
                        onChange={this.handleTableChange}
                        pagination={pagination}
                    />
                </Spin>
                <InGroupRate ref={el => this.inGroupRateRef = el} params={searchParams} />
            </div>
        );
    }
}

export default Recommend;


// WEBPACK FOOTER //
// ./src/components/siteComment/researchCenterRecommend/Recommend.js